import(/* webpackMode: "eager", webpackExports: ["ClientOnly"] */ "C:\\app\\visualCode\\workspace\\jsws_2_frontend\\src\\app\\[[...slug]]\\client.jsx");
